import { useForgotPasswordPage } from "./logic";
import { ForgotPasswordPageTemplate } from "./template";

export const ForgotPasswordPage = (): JSX.Element => {
  const data = useForgotPasswordPage();
  return <ForgotPasswordPageTemplate {...data} />;
};
